import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function ResetPassword() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset Password" subtitle="Choose a new password."
      footer={<Link to="/login" className="text-orange-400 font-semibold">{t("sign_in")}</Link>}>
      {!token ? (
        <p className="text-red-400 text-sm">Invalid or missing reset token.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>New {t("password")}</Label><Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="mt-1" /></div>
          <Button type="submit" disabled={busy} data-testid="reset-submit-button" className="w-full bg-orange-600 hover:bg-orange-500 btn-glow font-semibold py-6">{busy ? "..." : t("save")}</Button>
        </form>
      )}
    </AuthShell>
  );
}
